export const BonusId = {
  SKILL_POINT: 'skill_point',
  MECH_SKILL_POINT: 'mech_skill_point',
  TALENT_POINT: 'talent_point',
  LICENSE_POINT: 'license_point',
  CB_POINT: 'cb_point',
  PILOT_GEAR: 'pilot_gear',
  RANGE: 'range',
  DAMAGE: 'damage',
  HP: 'hp',
  ARMOR: 'armor',
  STRUCTURE: 'structure',
  STRESS: 'stress',
  HEATCAP: 'heatcap',
  REPCAP: 'repcap',
  CORE_POWER: 'core_power',
  SPEED: 'speed',
  EVASION: 'evasion',
  EDEF: 'edef',
  SENSOR: 'sensor',
  TECH_ATTACK: 'tech_attack',
  SAVE: 'save',
  SP: 'sp',
  SIZE: 'size',
  AI_CAP: 'ai_cap',
  CHEAP_STRUCT: 'cheap_struct',
  CHEAP_STRESS: 'cheap_stress',
  OVERCHARGE: 'overcharge',
  LIMITED_BONUS: 'limited_bonus',
  PILOT_HP: 'pilot_hp',
  PILOT_ARMOR: 'pilot_armor',
  PILOT_EVASION: 'pilot_evasion',
  PILOT_EDEF: 'pilot_edef',
  PILOT_SPEED: 'pilot_speed',
  PILOT_GEAR_SLOTS: 'pilot_gear_slots',
  PILOT_WEAPON_SLOTS: 'pilot_weapon_slots',
  PILOT_ARMOR_SLOTS: 'pilot_armor_slots',
  DEPLOYABLE_HP: 'deployable_hp',
  DEPLOYABLE_SIZE: 'deployable_size',
  DEPLOYABLE_CHARGES: 'deployable_charges',
  DEPLOYABLE_ARMOR: 'deployable_armor',
  DEPLOYABLE_EVASION: 'deployable_evasion',
  DEPLOYABLE_EDEF: 'deployable_edef',
  DEPLOYABLE_HEATCAP: 'deployable_heatcap',
  DEPLOYABLE_REPCAP: 'deployable_repcap',
  DEPLOYABLE_SENSOR_RANGE: 'deployable_sensor_range',
  DEPLOYABLE_TECH_ATTACK: 'deployable_tech_attack',
  DEPLOYABLE_SAVE: 'deployable_save',
  DEPLOYABLE_SPEED: 'deployable_speed',
  DEPLOY_COUNT: 'deploy_count',
  DRONE_HP: 'drone_hp',
  DRONE_SIZE: 'drone_size',
  DRONE_CHARGES: 'drone_charges',
  DRONE_ARMOR: 'drone_armor',
  DRONE_EVASION: 'drone_evasion',
  DRONE_EDEF: 'drone_edef',
  DRONE_HEATCAP: 'drone_heatcap',
  DRONE_REPCAP: 'drone_repcap',
  DRONE_SENSOR_RANGE: 'drone_sensor_range',
  DRONE_TECH_ATTACK: 'drone_tech_attack',
  DRONE_SAVE: 'drone_save',
  DRONE_SPEED: 'drone_speed',
  ACTIVATIONS: 'activations',
  ACTIVATIONS_PCT: 'activations_pct',
  HP_PER_PLAYER: 'hp_per_player',
  IMMUNITY: 'immunity',
  RESISTANCE: 'resistance',
  MOUNT_ACCURACY: 'mount_accuracy',
  MOUNT_RANGE: 'mount_range',
  MOUNT_DAMAGE: 'mount_damage',
  MOUNT_DAMAGE_TYPE: 'mount_damage_type (override)',
  MOUNT_RANGE_TYPE: 'mount_range_type (override)',
  MOUNT_WEAPON_TYPE: 'mount_weapon_type (override)',
  ADD_MOUNT: 'add_mount',
  NO_MODS: 'no_mods',
  ARMOR_MAX: 'armor_max',
  BOOST: 'boost',
  MIN_RANGE: 'min_range',
  MIN_DAMAGE: 'min_damage',
  EXTRA_ACTION: 'extra_action',
  UNSTABLE_SYSTEM: 'unstable_system',
  KNOCKBACK: 'knockback',
  ATTACK: 'attack',
  NO_CASCADE: 'no_cascade',
  THROWN: 'thrown',
  DRONE_RESIST: 'drone_resist',
  DEPLOYABLE_RESIST: 'deployable_resist',
  HULL: 'hull',
  AGILITY: 'agility',
  SYSTEMS: 'systems',
  ENGINEERING: 'engineering',
  CHECK: 'check',
  THREAT: 'threat',
  ADD_WEAPON_TYPE: 'add_weapon_type',
  GRAPPLE: 'grapple',
  RAM: 'ram',
  SIZES: 'sizes',
  MELEE: 'melee',
  HEAT_CAP: 'heat_cap',
  ACCURACY: 'accuracy',
} as const

export type BonusIdType = (typeof BonusId)[keyof typeof BonusId]

interface IBonusMeta {
  id: string
  title: string
  detail: string
}

const _coreEntries: IBonusMeta[] = [
  {
    id: 'skill_point',
    title: 'Pilot Skill Trigger',
    detail: "{INC_DEC} the Pilot's total available Skill selections by {VAL}",
  },
  {
    id: 'mech_skill_point',
    title: 'Mech Skill (HASE) Point',
    detail: "{INC_DEC} the Pilot's total available HULL/AGI/SYS/ENG selections by {VAL}",
  },
  {
    id: 'talent_point',
    title: 'Pilot Talent',
    detail: "{INC_DEC} the Pilot's total available Talent selections by {VAL}",
  },
  {
    id: 'license_point',
    title: 'Pilot License',
    detail: "{INC_DEC} the Pilot's total available License selections by {VAL}",
  },
  {
    id: 'cb_point',
    title: 'Pilot CORE Bonus',
    detail: "{INC_DEC} the Pilot's total available CORE Bonus selections by {VAL}",
  },
  {
    id: 'pilot_gear_slots',
    title: 'Pilot Gear Capacity',
    detail: "{INC_DEC} the Pilot's total available Pilot Gear capacity by {VAL}",
  },
    {
    id: 'pilot_weapon_slots',
    title: 'Pilot Weapon Capacity',
    detail: "{INC_DEC} the Pilot's total available Pilot Weapon capacity by {VAL}",
  },
  {
    id: 'range',
    title: 'Modified Weapon Range',
    detail:
      '{INC_DEC} weapon {RANGE_TYPES} by {VAL} for{DAMAGE_TYPES}{WEAPON_TYPES}{WEAPON_SIZES} weapons',
  },
  {
    id: 'damage',
    title: 'Modified Weapon Damage',
    detail: '{INC_DEC}{DAMAGE_TYPES}weapon damage by {VAL} for{WEAPON_TYPES}{WEAPON_SIZES} weapons',
  },
  {
    id: 'hp',
    title: 'HP',
    detail: '{INC_DEC} total Hit Points by {VAL}',
  },
  {
    id: 'armor',
    title: 'Armor',
    detail: '{INC_DEC} total Armor by {VAL}',
  },
  {
    id: 'structure',
    title: 'Structure',
    detail: '{INC_DEC} total Structure by {VAL}',
  },
  {
    id: 'stress',
    title: 'Reactor Stress',
    detail: '{INC_DEC} total Reactor Stress by {VAL}',
  },
  {
    id: 'heatcap',
    title: 'Heat Capacity',
    detail: '{INC_DEC} total Heat Capacity by {VAL}',
  },
  {
    id: 'repcap',
    title: 'Repair Capacity',
    detail: '{INC_DEC} total Repair Capacity by {VAL}',
  },
  {
    id: 'core_power',
    title: 'CORE Power',
    detail: '{INC_DEC} total CORE Power by {VAL}',
  },
  {
    id: 'speed',
    title: 'Speed',
    detail: '{INC_DEC} total Speed by {VAL}',
  },
  {
    id: 'evasion',
    title: 'Evasion',
    detail: '{INC_DEC} total Evasion by {VAL}',
  },
  {
    id: 'edef',
    title: 'E-Defense',
    detail: '{INC_DEC} total E-Defense by {VAL}',
  },
  {
    id: 'sensor',
    title: 'Sensor Range',
    detail: '{INC_DEC} total Sensor Range by {VAL}',
  },
  {
    id: 'tech_attack',
    title: 'Tech Attack',
    detail: '{INC_DEC} total Tech Attack by {VAL}',
  },
  {
    id: 'save',
    title: 'Save',
    detail: '{INC_DEC} total Save by {VAL}',
  },
  {
    id: 'sp',
    title: 'SP',
    detail: '{INC_DEC} total System Points by {VAL}',
  },
  {
    id: 'size',
    title: 'Modified Size',
    detail: '{INC_DEC} Size by {VAL}',
  },
  {
    id: 'ai_cap',
    title: 'AI Capacity',
    detail: '{INC_DEC} total AI Capacity by {VAL}',
  },
  {
    id: 'cheap_struct',
    title: 'Half Cost for Structure Repairs',
    detail: 'Structure repairs cost 1 Repair instead of 2',
  },
  {
    id: 'cheap_stress',
    title: 'Half Cost for Reactor Stress Repairs',
    detail: 'Reactor repairs cost 1 Repair instead of 2',
  },
  {
    id: 'overcharge',
    title: 'Modified Overcharge Track',
    detail: 'Modifies the Overcharge Heat Cost track',
  },
  {
    id: 'limited_bonus',
    title: 'Limited Equipment Uses',
    detail: '{INC_DEC} the total uses of Equipment with the "LIMITED X" Tag by {VAL}',
  },
  {
    id: 'pilot_hp',
    title: 'Pilot HP',
    detail: '{INC_DEC} total Pilot Hit Points by {VAL}',
  },
  {
    id: 'pilot_armor',
    title: 'Pilot Armor',
    detail: '{INC_DEC} total Pilot Armor by {VAL}',
  },
  {
    id: 'pilot_evasion',
    title: 'Pilot Evasion',
    detail: '{INC_DEC} total Pilot Evasion by {VAL}',
  },
  {
    id: 'pilot_edef',
    title: 'Pilot E-Defense',
    detail: '{INC_DEC} total Pilot E-Defense by {VAL}',
  },
  {
    id: 'pilot_speed',
    title: 'Add Pilot Speed',
    detail: '{INC_DEC} total Pilot Speed by {VAL}',
  },
  {
    id: 'pilot_gear_slots',
    title: 'Add Pilot Gear Slot',
    detail: '{INC_DEC} total Pilot Gear slots by {VAL}',
  },
  {
    id: 'pilot_weapon_slots',
    title: 'Add Pilot Weapon Slot',
    detail: '{INC_DEC} total Pilot Weapon slots by {VAL}',
  },
  {
    id: 'pilot_armor_slots',
    title: 'Add Pilot Armor Slot',
    detail: '{INC_DEC} total Pilot Armor slots by {VAL}',
  },
  {
    id: 'deployable_hp',
    title: 'HP for all Drones and Deployables',
    detail: '{INC_DEC} the total HP of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_size',
    title: 'Size for all Drones and Deployables',
    detail: '{INC_DEC} the Size of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_charges',
    title: 'Charges for all Drones and Deployables',
    detail: '{INC_DEC} the total available Charges for Drone and Deployable Equipment by {VAL}',
  },
  {
    id: 'deployable_armor',
    title: 'Armor for all Drones and Deployables',
    detail: '{INC_DEC} the Armor of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_evasion',
    title: 'Evasion for all Drones and Deployables',
    detail: '{INC_DEC} the Evasion of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_edef',
    title: 'E-Defense for all Drones and Deployables',
    detail: '{INC_DEC} the E-Defense of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_heatcap',
    title: 'Heat Capacity for all Drones and Deployables',
    detail: '{INC_DEC} the Heat Capacity of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_repcap',
    title: 'Repair Capacity for all Drones and Deployables',
    detail: '{INC_DEC} the Repair Capacity of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_sensor_range',
    title: 'Sensor Range for all Drones and Deployables',
    detail: '{INC_DEC} the Sensor Range of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_tech_attack',
    title: 'Tech Attack for all Drones and Deployables',
    detail: '{INC_DEC} the Tech Attack of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_save',
    title: 'Save for all Drones and Deployables',
    detail: '{INC_DEC} the Save of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_speed',
    title: 'Speed for all Drones and Deployables',
    detail: '{INC_DEC} the Speed of all deployed Deployables by {VAL}',
  },
  {
    id: 'deploy_count',
    title: 'Deployable Count',
    detail: 'Deploy {Val} additional Deployables per deploy action',
  },
  {
    id: 'drone_hp',
    title: 'HP for all Drones',
    detail: '{INC_DEC} the total HP of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_size',
    title: 'Size for all Drones',
    detail: '{INC_DEC} the Size of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_charges',
    title: 'Charges for all Drones',
    detail: '{INC_DEC} the total available Charges for Drone and Deployable Equipment by {VAL}',
  },
  {
    id: 'drone_armor',
    title: 'Armor for all Drones',
    detail: '{INC_DEC} the Armor of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_evasion',
    title: 'Evasion for all Drones',
    detail: '{INC_DEC} the Evasion of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_edef',
    title: 'E-Defense for all Drones',
    detail: '{INC_DEC} the E-Defense of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_heatcap',
    title: 'Heat Capacity for all Drones',
    detail: '{INC_DEC} the Heat Capacity of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_repcap',
    title: 'Repair Capacity for all Drones',
    detail: '{INC_DEC} the Repair Capacity of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_sensor_range',
    title: 'Sensor Range for all Drones',
    detail: '{INC_DEC} the Sensor Range of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_tech_attack',
    title: 'Tech Attack for all Drones',
    detail: '{INC_DEC} the Tech Attack of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_save',
    title: 'Save for all Drones',
    detail: '{INC_DEC} the Save of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_speed',
    title: 'Speed for all Drones',
    detail: '{INC_DEC} the Speed of all deployed Drones by {VAL}',
  },
  {
    id: 'activations',
    title: 'Activations',
    detail: 'Take {VAL} additional turns per round',
  },
  {
    id: 'activations_pct',
    title: 'Activations Per Player',
    detail:
      'Take an additional turn per round if there are {VAL} or more PC characters in the encounter',
  },
  {
    id: 'hp_per_player',
    title: 'HP Per Player',
    detail: '{INC_DEC} HP by {VAL} per PC characters in the encounter',
  },
  {
    id: 'immunity',
    title: 'Immunity',
    detail: 'Grants immunity to {VAL}. This negates all damage from the specified source.',
  },
  {
    id: 'resistance',
    title: 'Resistance',
    detail: 'Grants resistance to {VAL}. This reduces damage from the specified source by half.',
  },

  {
    id: 'mount_accuracy',
    title: 'Mount Accuracy',
    detail: 'Grants {VAL} accuracy to all attacks made by weapons on this mount',
  },
  {
    id: 'mount_range',
    title: 'Mount Range',
    detail: 'Grants {VAL} range to all attacks made by weapons on this mount',
  },
  {
    id: 'mount_damage',
    title: 'Mount Damage',
    detail: 'Adds an additional {VAL} damage to all attacks made by weapons on this mount',
  },
  {
    id: 'mount_damage_type (override)',
    title: 'Mount Damage Type',
    detail: 'Converts all mounted weapon damage to the {VAL} Damage',
  },
  {
    id: 'mount_range_type (override)',
    title: 'Mount Range Type',
    detail: 'Converts all mounted weapon range to {VAL} Range',
  },
  {
    id: 'mount_weapon_type (override)',
    title: 'Mount Weapon Type',
    detail: 'Converts all mounted weapon types to {VAL} Weapons',
  },
  {
    id: 'add_mount',
    title: 'Add Mount',
    detail: 'Adds a new {VAL} mount to this mech, if there are less than {MAX} mounts',
  },
  { id: 'no_mods', title: 'Not Modifiable', detail: 'This equipment cannot be modified' },
  {
    id: 'armor_max',
    title: 'Maximum Armor',
    detail: '{INC_DEC} the maximum armor value of the mech to {VAL}',
  },
  { id: 'boost', title: 'Boost Speed', detail: '{INC_DEC} the Boost speed of this mech to {VAL}' },
  { id: 'min_range', title: 'Minimum Range', detail: '{INC_DEC} minimum weapon range to {VAL}' },
  { id: 'min_damage', title: 'Minimum Damage', detail: '{INC_DEC} minimum weapon damage to {VAL}' },
  {
    id: 'extra_action',
    title: 'Extra Action',
    detail: 'Grants an additional {VAL} Action per Turn',
  },
  { id: 'unstable_system', title: 'Unstable System', detail: '', hidden: true },
  { id: 'knockback', title: 'Knockback', detail: '{INC_DEC} Knockback value by {VAL}' },
  { id: 'attack', title: '', detail: '{INC_DEC} Attack roll by {VAL}' },
  { id: 'no_cascade', title: 'Prevent Cascade', detail: '', hidden: true },
  { id: 'thrown', title: 'Thrown', detail: 'Adds Thrown {VAL}' },
  { id: 'drone_resist', title: 'Drone Resist', detail: 'Adds {VAL} Resistance to deployed Drones' },
  {
    id: 'deployable_resist',
    title: 'Deployable Resist',
    detail: 'Adds {VAL} Resistance to all deployed equipment',
  },
  { id: 'hull', title: 'Hull', detail: '{INC_DEC} Hull Check and Save rolls by {VAL}' },
  {
    id: 'agility',
    title: 'Agility',
    detail: '{INC_DEC} Agility Check and Save rolls by {VAL}',
  },
  {
    id: 'systems',
    title: 'Systems',
    detail: '{INC_DEC} Systems Check and Save rolls by {VAL}',
  },
  {
    id: 'engineering',
    title: 'Engineering',
    detail: '{INC_DEC} Engineering Check and Save rolls by {VAL}',
  },
  { id: 'check', title: 'Checks', detail: '{INC_DEC} all Check rolls by {VAL}' },
  { id: 'save', title: 'Saves', detail: '{INC_DEC} all Save rolls by {VAL}' },
  { id: 'threat', title: 'Threat', detail: '{INC_DEC} weapon Threat by {VAL}' },
  { id: 'add_weapon_type', title: 'Set Weapon Type', detail: 'Set weapon type to {VAL}' },
  { id: 'grapple', title: 'Threat', detail: '{INC_DEC} Grapple by {VAL}' },
  { id: 'ram', title: 'Ram', detail: '{INC_DEC} Ram by {VAL}' },
  { id: 'sizes', title: 'Size Options', detail: 'Extend NPC size creation options ({VAL})' },
  { id: 'melee', title: 'Melee', detail: '{INC_DEC} Melee attacks by {VAL}' },
  { id: 'heat_cap', title: 'Heat Cap', detail: '{INC_DEC} Heat Capacity by {VAL}' },
  {
    id: 'accuracy',
    title: 'Accuracy',
    detail: '{INC_DEC} attacks, checks, and saves by {VAL} accuracy',
  },
]

const _extensions: IBonusMeta[] = []

function registerBonus(entry: IBonusMeta): void {
  _extensions.push(entry)
}

function clearBonusExtensions(): void {
  _extensions.length = 0
}

function getBonusDictionary(): IBonusMeta[] {
  return [..._coreEntries, ..._extensions]
}

export { registerBonus, clearBonusExtensions, getBonusDictionary }
export type { IBonusMeta }
export default _coreEntries
